import styled from '@emotion/styled';

const SubmitContainer = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 24px;
`;

const StyledCancelButton = styled.button`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 6px;
  border: 1px solid var(--dk-line, #e7e9ec);
  background: var(--dk-bg, white);
  color: var(--dk-text, black);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  &:disabled {
    background-color: var(--dk-bg-subtle, #f5f6f7);
    color: var(--dk-text-secondary, #b0b4ba);
    border-color: var(--dk-line, #e7e9ec);
    cursor: not-allowed;
  }
`;

const StyledSubmitButton = styled.button`
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 6px;
  background: black;
  color: white;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  &:disabled {
    background-color: var(--dk-bg-strong, #e7e9ec);
    color: white;
    cursor: not-allowed;
  }
`;

export { SubmitContainer, StyledCancelButton, StyledSubmitButton };
